import React, { useState, useEffect } from 'react';
import ProductService from '../../../services/ProductService';
import { faArchive } from '@fortawesome/free-solid-svg-icons';
import CategoryService from '../../../services/CategoryService';
import CurrencyService from '../../../services/CurrencyService';
import CrudManager from '../../../components/common/CrudManager';

const Product = () => {
  const [categories, setCategories] = useState([]);
  const [currencies, setCurrencies] = useState([]);

  useEffect(() => {
    fetchCategories();
    fetchCurrencies();
    
    // Escuchar cambios de empresa y recargar categorías
    const handleCompanyChange = () => {
      fetchCategories();
    };

    window.addEventListener('companyChanged', handleCompanyChange);
    return () => {
      window.removeEventListener('companyChanged', handleCompanyChange);
    };
  }, []);

  const fetchCategories = async () => {
    try {
      const filters = { enabled: true };
      const data = await CategoryService.getAll(0, 10000, filters);
      setCategories(data.content || []);
    } catch (error) {
      console.error("Error fetching categories:", error.message);
    }
  };

  const fetchCurrencies = async () => {
    try {
      const filters = { enabled: true };
      const data = await CurrencyService.getAll(0, 1000, filters, { key: 'currencyCode', direction: 'ascending' });
      setCurrencies(data.content || []);
    } catch (error) {
      console.error("Error fetching currencies:", error.message);
      setCurrencies([]);
    }
  };

  // Definir columnas - estructura APLANADA (ultra-simple)
  const columns = [
    {
      key: 'productImage',
      label: 'product.image',
      sortable: false,
      // Formulario:
      showInForm: true,
      type: 'file',
      accept: 'image/*',
      fullWidth: true,
      changeButtonText: 'product.changeImage'
    },
    {
      key: 'name',
      label: 'product.name',
      sortable: true,
      // Formulario:
      showInForm: true,
      type: 'text',
      placeholder: 'product.productName',
      required: true,
      icon: 'fa-tag',
      // Filtro:
      showInFilter: true
    },
    {
      key: 'description',
      label: 'product.description',
      sortable: true,
      // Formulario:
      showInForm: true,
      type: 'textarea',
      placeholder: 'product.productDescription',
      rows: 3,
      fullWidth: true,
      icon: 'fa-align-left',
      maxLengthInGrid: 50,
      // Filtro:
      showInFilter: true,
      filterSize: 'large'
    },
    {
      key: 'category',
      label: 'product.category',
      sortable: true,
      // Formulario:
      showInForm: true,
      type: 'select',
      placeholder: 'product.selectCategory',
      required: true,
      icon: 'fa-folder',
      backendKey: 'categoryId',
      options: categories.map(cat => ({
        value: cat.id,
        label: cat.categoryName
      })),
      // Filtro:
      showInFilter: true,
      filterKey: 'categoryId'
    },
    {
      key: 'price',
      label: 'product.price',
      sortable: true,
      // Formulario:
      showInForm: true,
      type: 'number',
      placeholder: 'product.price',
      step: '0.01',
      min: '0',
      decimals: 2,
      icon: 'fa-dollar'
    },
    {
      key: 'currency',
      label: 'product.currency',
      sortable: true,
      // Formulario:
      showInForm: true,
      type: 'select',
      placeholder: 'product.currency',
      required: true,
      icon: 'fa-money',
      backendKey: 'currencyId',
      options: currencies.map(currency => ({
        value: currency.id,
        label: `${currency.currencyCode} - ${currency.currencyName}`
      })),
      // Filtro:
      showInFilter: true,
      filterKey: 'currencyId'
    },
    {
      key: 'enabled',
      label: 'product.enabled',
      showInGrid: false,
      sortable: false,
      // Solo filtro:
      showInFilter: true,
      filterType: 'checkbox',
      filterSize: 'small'
    }
  ];

  return (
    <CrudManager
      service={ProductService}
      columns={columns}
      entityName="product"
      icon={faArchive}
      formLayout="inline"
      stayOnCancelInEdit={true}
    />
  );
};

export default Product;

